// Product clinical studies — scroll-triggered bar animations
(function() {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var barFills = document.querySelectorAll('.clinical-studies__bar-fill');
  if (!barFills.length) return;

  // Set CSS custom property for target width
  barFills.forEach(function(bar) {
    var width = bar.getAttribute('data-width') || 0;
    bar.style.setProperty('--bar-width', width + '%');
  });

  // If reduced motion, show bars immediately
  if (reducedMotion) {
    barFills.forEach(function(bar) {
      bar.classList.add('is-animated');
    });
    return;
  }

  // Animate bars on scroll into view
  var barObserver = new IntersectionObserver(
    function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var bars = entry.target.querySelectorAll('.clinical-studies__bar-fill');
          bars.forEach(function(bar, i) {
            setTimeout(function() {
              bar.classList.add('is-animated');
            }, i * 120);
          });
          barObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  document.querySelectorAll('.clinical-studies__group').forEach(function(group) {
    barObserver.observe(group);
  });
})();
